import React, { useState } from 'react';
import { logoutSession, clearAuthSession } from '../utils/security';

const EditIcon = () => (
    <svg width="14" height="14" viewBox="0 0 512 512" fill="currentColor" style={{ display: 'inline-block', verticalAlign: '-0.125em' }}>
        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z" />
    </svg>
);

const SaveIcon = () => (
    <svg width="14" height="14" viewBox="0 0 448 512" fill="currentColor" style={{ display: 'inline-block', verticalAlign: '-0.125em' }}>
        <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 90.5C340 78.5 323.7 71.7 306.7 71.7L288 71.7 288 192c0 17.7-14.3 32-32 32L128 224c-17.7 0-32-14.3-32-32l0-160 32 0 0 128 128 0 0-128 32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 18.7 0L416 173.3 416 416c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 16 0z" />
    </svg>
);

const TimesIcon = () => (
    <svg width="14" height="14" viewBox="0 0 384 512" fill="currentColor" style={{ display: 'inline-block', verticalAlign: '-0.125em' }}>
        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
    </svg>
);

export function ProfileContent({ isMobileDrawer }) {
    const [editingField, setEditingField] = useState(null);
    const [editedValue, setEditedValue] = useState('');

    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const name = localStorage.getItem('name');
    const birthdate = localStorage.getItem('age');
    const email = localStorage.getItem('email');
    const gender = localStorage.getItem('gender');
    const height = localStorage.getItem('height');
    const weight = localStorage.getItem('weight');
    const neck = localStorage.getItem('neck');
    const waist = localStorage.getItem('waist');

    const calculateAge = (dob) => {
        const today = new Date();
        const birthDate = new Date(dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const age = birthdate ? calculateAge(birthdate) : 'N/A';

    const handleEdit = (field) => {
        setEditingField(field);
        setEditedValue(localStorage.getItem(field));
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        const rounded = value === '' ? '' : parseFloat(value).toFixed(1);
        setEditedValue(rounded);
    };

    const handleSave = async () => {
        const roundedValue = parseFloat(parseFloat(editedValue).toFixed(1)).toFixed(1);
        localStorage.setItem(editingField, roundedValue);
        setEditedValue(roundedValue);
        setEditingField(null);

        const updatedData = { [editingField]: roundedValue };

        try {
            const response = await fetch('https://thefitrealm.in/api/updateUser', {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedData)
            });

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    clearAuthSession();
                    window.location.href = '/login';
                }
            }
        } catch {
            // Silently handle error
        }
    };

    const handleCancel = () => {
        setEditingField(null);
    };

    if (isLoggedIn) {
        return (
            <div className={isMobileDrawer ? 'modal-div' : undefined}>
                <div className="modal-header">
                    <img src="/images/user.webp" alt="Profile - Fit Realm" className="profile-icon-large" width="60" height="60" />
                    <h3>{name}, {age}</h3>
                </div>
                {!isMobileDrawer && <hr />}
                <div className="modal-body">
                    <ul>
                        <li><strong>Email:</strong> {email}</li>
                        <li><strong>Gender:</strong> {gender}</li>
                        <li className="container align-items-start">
                            <strong>Height:</strong>
                            {editingField === 'height' ? (
                                <div>
                                    <input type="text" name="height" value={editedValue} onChange={handleInputChange} />
                                    <div className="edit-buttons mt-2 justify-content-end">
                                        <button className="btn btn-primary" onClick={handleSave}><SaveIcon /> Save</button>
                                        <button className="btn btn-secondary" onClick={handleCancel}><TimesIcon /> Cancel</button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {height !== null && height !== 'null' ? `${height} cm` : '-'}
                                    <button className="edit-icon" onClick={() => handleEdit('height')}>
                                        <EditIcon />
                                    </button>
                                </div>
                            )}
                        </li>
                        <li className="container align-items-start">
                            <strong>Weight:</strong>
                            {editingField === 'weight' ? (
                                <div>
                                    <input type="text" name="weight" value={editedValue} onChange={handleInputChange} />
                                    <div className="edit-buttons mt-2 justify-content-end">
                                        <button className="btn btn-primary" onClick={handleSave}><SaveIcon /> Save</button>
                                        <button className="btn btn-secondary" onClick={handleCancel}><TimesIcon /> Cancel</button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {weight !== null && weight !== 'null' ? `${weight} kg` : '-'}
                                    <button className="edit-icon" onClick={() => handleEdit('weight')}>
                                        <EditIcon />
                                    </button>
                                </div>
                            )}
                        </li>
                        <li className="container align-items-start">
                            <strong>Neck:</strong>
                            {editingField === 'neck' ? (
                                <div>
                                    <input type="text" name="neck" value={editedValue} onChange={handleInputChange} />
                                    <div className="edit-buttons mt-2 justify-content-end">
                                        <button className="btn btn-primary" onClick={handleSave}><SaveIcon /> Save</button>
                                        <button className="btn btn-secondary" onClick={handleCancel}><TimesIcon /> Cancel</button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {neck !== null && neck !== 'null' ? `${neck} cm` : '-'}
                                    <button className="edit-icon" onClick={() => handleEdit('neck')}>
                                        <EditIcon />
                                    </button>
                                </div>
                            )}
                        </li>
                        <li className="container align-items-start">
                            <strong>Waist:</strong>
                            {editingField === 'waist' ? (
                                <div>
                                    <input type="text" name="waist" value={editedValue} onChange={handleInputChange} />
                                    <div className="edit-buttons mt-2 justify-content-end">
                                        <button className="btn btn-primary" onClick={handleSave}><SaveIcon /> Save</button>
                                        <button className="btn btn-secondary" onClick={handleCancel}><TimesIcon /> Cancel</button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {waist !== null && waist !== 'null' ? `${waist} cm` : '-'}
                                    <button className="edit-icon" onClick={() => handleEdit('waist')}>
                                        <EditIcon />
                                    </button>
                                </div>
                            )}
                        </li>
                    </ul>
                    <button className={isMobileDrawer ? 'logout-btn' : 'btn col-12 logout-btn'} onClick={async () => {
                        try {
                            await logoutSession();
                            window.location.href = '/';
                        } catch {
                            alert("Logout failed. Please check your internet connection and try again.");
                        }
                    }}>Log Out</button>
                </div>
            </div>
        );
    }

    return (
        <div className={isMobileDrawer ? 'auth-section' : 'auth-section container'}>
            <div>
                <img src="/images/user.webp" alt="Profile - Fit Realm" className="profile-icon-large" width="60" height="60" />
                <h5>Please log in or sign up</h5>
            </div>
            <div className="auth-buttons">
                <button className={isMobileDrawer ? 'login-btn' : 'btn btn-primary col-4'} style={!isMobileDrawer ? { marginRight: '15px' } : undefined} onClick={() => window.location.href = '/login'}>Login</button>
                <button className={isMobileDrawer ? 'sign-btn' : 'btn btn-light col-4'} onClick={() => window.location.href = '/signup'}>Signup</button>
            </div>
        </div>
    );
}

export default function ProfileModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay1" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <ProfileContent isMobileDrawer={false} />
            </div>
        </div>
    );
}
